import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSparks16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconSparks16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11.515 1a.5.5 0 0 0-.5.5c0 .836-.678 1.514-1.514 1.515H9.5a.5.5 0 1 0 0 1c.837 0 1.515.679 1.515 1.515a.5.5 0 0 0 1 0c0-.837.678-1.515 1.515-1.515a.5.5 0 0 0 0-1A1.515 1.515 0 0 1 12.015 1.5a.5.5 0 0 0-.5-.5m.51 2.515a2.5 2.5 0 0 1-.51-.51 2.5 2.5 0 0 1-.51.51q.291.218.51.51.218-.292.51-.51m-6.48-.096a.5.5 0 0 0-.5.5 3.05 3.05 0 0 1-3.046 3.048h-.002a.5.5 0 1 0 0 1H2a3.05 3.05 0 0 1 3.046 3.048.5.5 0 0 0 1 0 3.05 3.05 0 0 1 3.048-3.048.5.5 0 1 0 0-1A3.05 3.05 0 0 1 6.045 3.92a.5.5 0 0 0-.5-.5m1.597 4.048A4.07 4.07 0 0 1 5.545 5.87a4.07 4.07 0 0 1-1.598 1.597c.672.37 1.228.926 1.598 1.598a4.07 4.07 0 0 1 1.597-1.598m4.383 1.5a.5.5 0 0 1 .5.5v1.024a.5.5 0 1 1-1 0V9.467a.5.5 0 0 1 .5-.5m0 5.095a.5.5 0 0 1-.5-.5V12.54a.5.5 0 0 1 1 0v1.024a.5.5 0 0 1-.5.5m2.048-2.047a.5.5 0 0 0 0-1h-1.024a.5.5 0 1 0 0 1zm-4.595-.5a.5.5 0 0 1 .5-.5h1.024a.5.5 0 1 1 0 1H9.478a.5.5 0 0 1-.5-.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSparks16);
